export default __webpack_public_path__ + "static/media/caret-sort.7c99ff57.svg";